import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MenuItem from "../../Menu/MenuItem/MenuItem";
import Heading from "../../shared_components/Heading/Heading";
import SubMenuContainer from "../../shared_components/SubMenuContainer/SubMenuContainer";
import WhiteMainBackground from "../../shared_components/WhiteMainBackground/WhiteMainBackground";
import NotFound from "../NotFound/NotFound";
import style from "./AIIntelligence.module.css";
import IngestionBatches from "./IngestionBatches/IngestionBatches";
import IngestedDocuments from "./IngestedDocuments/IngestedDocuments";
import RunDocumentDetails from "./PreEnrichmentRuns/RunDocumentDetails";
import RunDocuments from "./PreEnrichmentRuns/RunDocuments";
import PreEnrichmentRuns from "./PreEnrichmentRuns/PreEnrichmentRuns";
import RulesetRules from "./PreEnrichmentRulesets/RulesetRules";
import PreEnrichmentRulesets from "./PreEnrichmentRulesets/PreEnrichmentRulesets";

import DocumentContent from "./IngestedDocuments/DocumentContent";

const AIIntelligence = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={`${style.container} ${collapsed ? style.collapsed : ""}`}>
      <WhiteMainBackground className={style.sidebar}>
        <SubMenuContainer>
          <div className={style.menuHeader}>
            {!collapsed && <Heading>AI Intelligence</Heading>}
            <button
              type="button"
              className={style.toggle}
              onClick={() => setCollapsed(value => !value)}
              aria-expanded={!collapsed}
              aria-controls="intelligence-submenu"
              aria-label={collapsed ? "Expand AI Intelligence menu" : "Collapse AI Intelligence menu"}
              title={collapsed ? "Expand menu" : "Collapse menu"}
            >
              {collapsed ? <ChevronRight size={22} /> : <ChevronLeft size={22} />}
            </button>
          </div>
          <nav id="intelligence-submenu" aria-label="AI Intelligence" hidden={collapsed}>
            <MenuItem path="/intelligence/ingestion-batches">Ingestion Batches</MenuItem>
            <MenuItem path="/intelligence/documents">Ingested Documents</MenuItem>
            <MenuItem path="/intelligence/pre-enrichment-runs">Pre-Enrichment Runs</MenuItem>
            <MenuItem path="/intelligence/pre-enrichment-rulesets">Pre-Enrichment Rulesets</MenuItem>
          </nav>
        </SubMenuContainer>
      </WhiteMainBackground>
      <WhiteMainBackground className={style.main}>
        <Routes>
          <Route index element={<Navigate to="ingestion-batches" replace />} />
          <Route path="ingestion-batches" element={<IngestionBatches />} />
          <Route path="documents" element={<IngestedDocuments />} />
          <Route path="pre-enrichment-runs" element={<PreEnrichmentRuns />} />
          <Route path="pre-enrichment-rulesets/:rulesetId/rules" element={<RulesetRules />} />
          <Route path="pre-enrichment-rulesets" element={<PreEnrichmentRulesets />} />
          <Route path="pre-enrichment-runs/:runId/documents/:documentId" element={<RunDocumentDetails />} />
          <Route path="pre-enrichment-runs/:runId/documents" element={<RunDocuments />} />
          <Route path="documents/:sourceDocumentId/content" element={<DocumentContent />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </WhiteMainBackground>
    </div>
  );
};

export default AIIntelligence;
